import React from 'react'
import { ThankYouButton } from '../../utils/AppText'
import '../../assets/css/Thankyou.css'
const DairitenThankYou = () => {
    document.title = 'お問い合わせ／エントリー｜メットライフ生命'
    return (
        < div className="dairiten-input-section-inputdetails" style={{ height: '800px' }}>
            <div className="card-container-inputdetails row">
                <div id="popup_container" style={{ textAlign: 'left' }}>
                <h1 className="h1Style01">お問い合わせありがとうございました</h1>
                    <p className="txtC tm50 bm50">&nbsp;お問い合わせを承りました。<br></br>
                    今後、担当者を選定のうえご連絡いたします。<br></br>
                    ご連絡までに約1週間程度お時間をいただく場合がございますので、今しばらくお待ちください。</p>
                </div>
            </div>
            <div className="d-grid" style={{ justifyContent: 'center' }}>
                <a href='https://www.metlife.co.jp'><button type="button" className="btn btn-secondary">{ThankYouButton}</button></a>
            </div>
        </div >
    )
}

export default DairitenThankYou
